import { useQuery } from "@tanstack/react-query";
import { getLexiconSubjectsApiLexiconSubjectsGet, type LexiconSubjectItem } from "@noa/api-core";
import { LexiconQueryKey } from "../../query-keys";

const fetchLexiconSubjects = async () => {
  const { data } = await getLexiconSubjectsApiLexiconSubjectsGet({ throwOnError: true });
  return data;
};

/**
 * Stable reference for the not-yet-loaded case.
 *
 * A fresh `[]` here would be a new identity on every render while the query is
 * pending or errored, invalidating every `useMemo` keyed on the result — the
 * option lists downstream would rebuild on each keystroke.
 */
const NO_SUBJECTS: LexiconSubjectItem[] = [];

export const useGetLexiconSubjects = () => {
  const { data, isPending, ...rest } = useQuery({
    queryKey: LexiconQueryKey.subjects(),
    queryFn: fetchLexiconSubjects,
    // Subjects change only when someone adds one, but the list is fetched by
    // every concept form — including the in-chat card, which remounts on each
    // expand. Without this the default staleTime of 0 refetches every time.
    staleTime: 5 * 60_000,
  });

  const subjects = data?.subjects ?? NO_SUBJECTS;

  return { subjects, isLoadingSubjects: isPending, ...rest };
};
